import { Button, Icon, message, Row, Typography, Upload, Select, Input } from "antd";
import { ReactComponent as Logoo } from "./Svgs/Language.svg";
import React, { useEffect, useState } from 'react'
import { addLanguageEquivalentApi, getLanguagesApi, updateLanguageEquivalentApi } from "utils/apiService";
import { useDispatch, useSelector } from "react-redux";
import { getAllLabelsData } from "actions/MultiLanguageActions";
const { Text } = Typography;
const { Option } = Select;

export default function AddLanguageEquivalentModal(props) {
    const { closeModal } = props;
    const [StoreImageFile, setStoreImageFile] = useState(null);
    const [labelEquivalentValue, setLabelEquivalentValue] = useState({
        language: "",
        label_uuid: "",
        value: ""
    });
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [languagesData, setLanguagesData] = useState([]);
    const { MultiLanguageReducer } = useSelector((state) => state);
    const dispatch = useDispatch()

    useEffect(() => {
        getLanguagesApi({
            requestData: {},
            res200Callback: (res) => {
                setLanguagesData(res.data.languages);
            },
        });
    }, [])

    const formValidation = (label) => {
        // const { address, city, country, region, latitude, longitude } = Label;
        // console.log("formValidationdata", label);
        // let isNumber = /[+-]?([0-9]*[.])?[0-9]+/;
        for (var key of Object.keys(label)) {
            if (label[key] == "" || !label[key]) {
                message.error(`${key} is required`);
                return false;
            }
        }
        return true;
    };

    const addLabelEquivalent = async (label, loadTable) => {
        // console.log(storeDetails);
        if (!formValidation(label)) {
            return;
        }
        addLanguageEquivalentApi({
            requestData: label,
            res200Callback: () => {
                message.success("Label updated successfully.");
                // fetchLabelData();
                getAllLabelsData(dispatch)
                closeModal()
                // setDisableModal(false);
                // toggleModal();
                // props.loadTable();
            },
            resErrorCallback: () => {
                message.error("Failed updating the store !");
            },
        });
    };

    return (
        <div>
            <Row className="modal-row">
                <Row>
                    <div style={{ display: "flex" }}>
                        <div>
                            <Logoo style={{ marginTop: "2px" }} />
                        </div>
                        <Text
                            style={{
                                marginLeft: "16px",
                                fontWeight: "700",
                                color: "#181818",
                                fontSize: "24px",
                                fontStyle: "normal",
                                lineHeight: "40px",
                            }}>
                            Add Language Equivalent
                        </Text>
                    </div>
                </Row>
                <div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>
                <Row className="stores_wrapper" >
                    <div>
                        <div
                            style={{
                                // marginTop: "32px",
                                width: "100%",
                            }}>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    fontWeight: "bold",
                                }}>
                                Select language
                            </Text>
                            <Select
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Select language"
                                name="language"
                                value={labelEquivalentValue.language}
                                onChange={(value) => {
                                    setLabelEquivalentValue({
                                        ...labelEquivalentValue,
                                        ["language"]: value,
                                    });
                                }}>
                                {languagesData.map((valuee) => {
                                    return (
                                        <Option value={valuee}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {valuee}
                                            </div>
                                        </Option>
                                    );
                                })}
                            </Select>
                        </div>
                        {labelEquivalentValue.language && <div
                            style={{
                                marginTop: "32px",
                                width: "100%",
                            }}>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    fontWeight: "bold",
                                    // fontWeight:"bold"
                                }}>
                                Select Label
                            </Text>
                            <Select
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Select language"
                                name="label_uuid"
                                // value={storelocation.country}
                                onChange={(value) => {
                                    setLabelEquivalentValue({
                                        ...labelEquivalentValue,
                                        ["label_uuid"]: value,
                                    });
                                }}>
                                {MultiLanguageReducer?.multiLanguageLabelsList?.languages_data[labelEquivalentValue.language].map((valuee) => {
                                    return (
                                        valuee.translation_value == "" &&
                                        <Option value={valuee.label_uuid}>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                {valuee.name}
                                            </div>
                                        </Option>
                                    );
                                })}
                            </Select>
                        </div>
                        }
                        <div
                            style={{
                                marginTop: "32px",
                                //   display: "flex",
                            }}>
                            <Text
                                style={{
                                    fontSize: "14px",
                                    color: "#181818",
                                    fontWeight: "bold",
                                    // fontWeight:"bold"
                                }}>
                                Language Equivalent
                            </Text>
                            <Input
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Enter Language Equivalent Label"
                                // onChange={(e) => {
                                //   addStoreManually.current.name = e.target.value;
                                // }}
                                value={labelEquivalentValue.value}
                                onChange={(event) => {
                                    setLabelEquivalentValue({
                                        ...labelEquivalentValue,
                                        [event.target.name]: event.target.value,
                                    });
                                }}
                                name="value"
                            />
                        </div>

                    </div>

                    <div
                        style={{
                            marginTop: "24px ",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></div>
                    <Row
                        type="flex"
                        justify="end"
                        align="middle"
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                boxShadow: "none",
                                borderRadius: "20px",
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                color: "#181818",
                                marginRight: "12px",
                            }}
                            onClick={() => {
                                closeModal()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={() => {
                                addLabelEquivalent(labelEquivalentValue)
                                // addStore(setStoreDeatils, storeDetails, storelocation, StoreImageFile, setaddModal, loadTable);
                            }}>
                            Add Language Equivalent
                        </Button>
                    </Row>
                </Row>
            </Row>
        </div>
    )
}
